import { render, staticRenderFns } from "./DeleteDataButton.vue?vue&type=template&id=35a7d945&scoped=true"
import script from "./DeleteDataButton.vue?vue&type=script&lang=js"
export * from "./DeleteDataButton.vue?vue&type=script&lang=js"
import style0 from "./DeleteDataButton.vue?vue&type=style&index=0&id=35a7d945&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a7d945",
  null
  
)

export default component.exports